export enum Status {
    INITIAL,
    UPDATING,
    LOADING,
    SUCCESS,
    ERROR,
}

export enum ErrorType {
    INITIAL = '',
    INVALID_EMAIL = 'Invalid email',
    SAILTHRU = 'Error Occurred',
}

export interface IEmailCaptureState {
    status: Status;
    error: ErrorType;
}
